module.exports = __webpack_public_path__ + "img/mastercard.5c71b79b.jpg";